import React, { useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Form,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  CardTitle,
  ModalBody,
  ModalFooter,
  CardSubtitle,
} from 'reactstrap'
import { isEmpty, remove, get } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'
import ProductCard from '../../../components/Common/ProductCard'
import { getImagesOfProduct } from '../../../helpers/utils'

const FormPage = (props) => {
  const generalContext = useContext(GeneralContext)
  const { loading, setLoading } = generalContext

  const [products, setProducts] = useState([])
  const [productsSelected, setProductsSelected] = useState([])
  const [saveModal, setSaveModal] = useState(false)

  const storeId = get(props, 'match.params.storeId', false)

  const toggleSaveModal = () => setSaveModal(!saveModal)

  async function fetchStoreInitProducts() {
    try {
      setLoading(true)
      const response = await ApiService.getStoreInitProducts()
      if (response.data.success) {
        setProducts(response.data.products)
      }
    } catch(e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    (async () => {
      await fetchStoreInitProducts()
    })()
  }, []) // eslint-disable-line

  const handleSubmit = async (e) => {
    e.preventDefault()
    toggleSaveModal()
  }

  const save = async () => {
    toggleSaveModal()
    setLoading(true)
    const data = {
      storeId,
      productsSelected
    }
    try {
      const response = await ApiService.addProductsToStore(data)
      if (response.data.success) {
        props.history.push(`/mi-tienda/${storeId}/compartir`)
      }
    } catch(e) {
      toastr.error(`${e.response.data.message}`, 'Error')
    } finally {
      setLoading(false)
    }
  }

  const addProduct = (itemChecked, item) => {
    const productsSelectedTemp = productsSelected
    if (itemChecked) {
      productsSelectedTemp.push(item)
      setProductsSelected([...productsSelectedTemp])
    } else {
      remove(productsSelectedTemp, n => n.id === item.id)
      setProductsSelected([...productsSelectedTemp])
    }
  }

  return (
    <React.Fragment>
      <Form id="create" method="POST">
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <CardTitle className="flex-fill">Productos</CardTitle>
                { !isEmpty(products) && (
                  <CardSubtitle className="flex-fill">Estos son algunos productos recomendados para tu tienda, pero una vez que la crees, podrás agregar más productos las veces que creas necesario.</CardSubtitle>
                )}
                <Row>
                  {products && products.map(
                    (item, key) => (
                      <Col key={key} sm={3} style={{ textAlign: 'center', marginBottom: '15px' }}>
                        <ProductCard
                          photos={getImagesOfProduct(item.gallery)}
                          code={`${item.supplierCode ? `Código ${item.supplierCode}` : ''}`}
                          price={`${item.wholeSalePrice || 0}`}
                          productName={item.name}
                          supplierName={item.supplier ? item.supplier.nombreComercial : ''}
                          showVariants={false}
                          showSelectMultiple
                          textAddProductMultipleButton="Agregar"
                          textRemoveProductMultipleButton="Eliminar"
                          actionAddProductMultiple={(itemChecked) => addProduct(itemChecked, item)}
                        />
                      </Col>
                    )
                  )}
                </Row>
                { !isEmpty(products) && (
                  <CardSubtitle>Puedes agregar más productos, desde la sección "Mi tienda" una vez que la publiques.</CardSubtitle>
                )}
              </CardBody>
            </Card>
            <Card style={{textAlign: 'right'}}>
              <CardBody>
                <Button
                  onClick={() => { window.history.go(-1) }}
                  className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                >
                  Cancelar
                </Button>
                <Button
                  color="primary"
                  onClick={handleSubmit}
                  className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                  disabled={loading || isEmpty(productsSelected)}
                >
                  Publicar mi tienda
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Form>
      <div>
        <Modal isOpen={saveModal} toggle={toggleSaveModal}>
          <ModalHeader toggle={toggleSaveModal}>Publicar mi tienda</ModalHeader>
          <ModalBody>
            ¿Está seguro que desea publicar su tienda?
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleSaveModal}>Cancelar</Button>{' '}
            <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={() => save()}>Publicar mi tienda</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default withRouter(FormPage)
